<template>
  <div>forgot</div>
</template>

<script>
export default {
  name: "ForgotPassword",
};
</script>

<style></style>
